import { Injectable } from '@angular/core';
import { SocketService } from './socket.service';
import { TransactionService } from './transaction.service';
import { HttpClient } from '@angular/common/http';
import { KeycodesService } from './keycodes.service';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class ControlService {




  screenshots: any[] = [];
  target: any;
  channel: any;
  clipboardContent: any;

  constructor(
    private socketService: SocketService,
    private transactionService: TransactionService,
    private http: HttpClient,
    private keycodesService: KeycodesService
  ) {
    this.target = sessionStorage.getItem("device");
    this.channel = sessionStorage.getItem("channel");
    // // Add event listener for keydown events
    // window.addEventListener('keyDown', this.handleKeyDown.bind(this));
    // window.addEventListener('keyup', this.handleKeyUp.bind(this));
  }




  private sendOneWay(action, data) {


    this.socketService.socket.emit(action, this.channel, data);
  }

  private sendTwoWay(action, data?: any) {
    let tx = this.transactionService.create(this.target) as any;
    // ios change
    if (this.target.ios && this.target.ios === true) {
      this.socketService.socket.emit(action, this.channel, tx.channel, data)
    } else {
      this.socketService.socket.emit(action, this.channel, tx.channel, data)
    }
    // ios change
    // this.socketService.socket.emit(action, this.channel, tx.channel, data)

    return tx.promise
  }

  private sendTwoWayIos(action, data?: any) {
    let tx: any = this.transactionService.create(this.target) as any;
    this.socketService.socket.emit(action, this.channel, tx.channel, data)
    return tx.promise
  }


  private keySender(type, fixedKey?: string) {

    return (key) => {
      if (typeof key === 'string') {
        this.sendOneWay(type, {
          key: key
        })
      }
      else {
        let mapped = fixedKey || this.keycodesService[key]
        if (mapped) {
          this.sendOneWay(type, {
            key: mapped
          })
        }
      }
    }
  }

  public gestureStart = (seq) => {
    this.sendOneWay('input.gestureStart', { seq: seq })
  }

  public gestureStop = (seq) => {
    this.sendOneWay('input.gestureStop', {
      seq: seq
    })
  }

  public touchDown = (seq, contact, x, y, pressure) => {


    this.sendOneWay('input.touchDown', {
      seq: seq
      , contact: contact
      , x: x
      , y: y
      , pressure: pressure
    })
  }

  //ios change
  public touchDownIos = (seq, contact, x, y, pressure) => {


    this.sendOneWay('input.touchDownIos', {
      seq: seq
      , contact: contact
      , x: x
      , y: y
      , pressure: pressure
    })
  }
  //ios change

  public touchMove = (seq, contact, x, y, pressure) => {
    this.sendOneWay('input.touchMove', {
      seq: seq
      , contact: contact
      , x: x
      , y: y
      , pressure: pressure
    })
  }

  // ios change
  public touchMoveIos = function (x, y, pX, pY, pressure, contact, seq) {
    this.sendOneWay('input.touchMoveIos', {
      seq: seq
      , contact: contact
      , toX: x
      , toY: y
      , fromX: pX
      , fromY: pY
      , pressure: pressure
    })
  }

  public touchMoveIos2 = function (seq, contact, x, y, pressure) {
    this.sendOneWay('input.touchMoveIos', {
      seq: seq
      , contact: contact
      , x: x
      , y: y
      , pressure: pressure
    })
  }
  // ios change

  public touchUp = (seq, contact) => {
    this.sendOneWay('input.touchUp', {
      seq: seq
      , contact: contact
    })
  }

  public touchCommit = (seq) => {
    this.sendOneWay('input.touchCommit', {
      seq: seq
    })
  }

  public touchReset = (seq) => {
    this.sendOneWay('input.touchReset', {
      seq: seq
    })
  }

  public keyDown = this.keySender('input.keyDown');
  public keyUp = this.keySender('input.keyUp');
  public keyPress = this.keySender('input.keyPress')

  public home = this.keySender('input.keyPress', 'home')
  public menu = this.keySender('input.keyPress', 'menu') //menu tha idhar
  public back = this.keySender('input.keyPress', 'back')
  public appSwitch = this.keySender('input.keyPress', 'app_switch')

  public geoLocation = function (longitude, latitude) {
    this.sendOneWay('input.geoLocation', {
      longitude: longitude,
      latitude: latitude
    });
  }
  //different switches for different languages
  public ur = this.keySender('input.keyPress', 'ur');
  public lt = this.keySender('input.keyPress', 'lt');
  public ja = this.keySender('input.keyPress', 'ja');
  public id = this.keySender('input.keyPress', 'id');
  public mr = this.keySender('input.keyPress', 'mr');
  public ms = this.keySender('input.keyPress', 'ms');
  public hi = this.keySender('input.keyPress', 'hi');
  public es_419 = this.keySender('input.keyPress', 'es-419');
  public es = this.keySender('input.keyPress', 'es');
  public pl = this.keySender('input.keyPress', 'pl');
  public ca = this.keySender('input.keyPress', 'ca');
  public ta = this.keySender('input.keyPress', 'ta');
  public fr = this.keySender('input.keyPress', 'fr');
  public en_IN = this.keySender('input.keyPress', 'en-IN');
  public or = this.keySender('input.keyPress', 'or');
  public fr_CA = this.keySender('input.keyPress', 'fr-CA');
  public da = this.keySender('input.keyPress', 'da');
  public bg = this.keySender('input.keyPress', 'bg');
  public te = this.keySender('input.keyPress', 'te');
  public kk_Cyrl = this.keySender('input.keyPress', 'kk-Cyrl');
  public pt_BR = this.keySender('input.keyPress', 'pt-BR');
  public zh_Hant_HK = this.keySender('input.keyPress', 'zh-Hant-HK');
  public hr = this.keySender('input.keyPress', 'hr');
  public gu = this.keySender('input.keyPress', 'gu');
  public de = this.keySender('input.keyPress', 'de');
  public th = this.keySender('input.keyPress', 'th');
  public sk = this.keySender('input.keyPress', 'sk');
  public ro = this.keySender('input.keyPress', 'ro');
  public sl = this.keySender('input.keyPress', 'sl');
  public nb = this.keySender('input.keyPress', 'nb');
  public kk = this.keySender('input.keyPress', 'kk');
  public en_GB = this.keySender('input.keyPress', 'en-GB');
  public hu = this.keySender('input.keyPress', 'hu');
  public zh_HK = this.keySender('input.keyPress', 'zh-HK');
  public bn = this.keySender('input.keyPress', 'bn');
  public ar = this.keySender('input.keyPress', 'ar');
  public it = this.keySender('input.keyPress', 'it');
  public kn = this.keySender('input.keyPress', 'kn');
  public ko = this.keySender('input.keyPress', 'ko');
  public uk = this.keySender('input.keyPress', 'uk');
  public pa = this.keySender('input.keyPress', 'pa');
  public ru = this.keySender('input.keyPress', 'ru');
  public vi = this.keySender('input.keyPress', 'vi');
  public zh_Hans = this.keySender('input.keyPress', 'zh-Hans');
  public zh_Hant = this.keySender('input.keyPress', 'zh-Hant');
  public en_AU = this.keySender('input.keyPress', 'en-AU');
  public ml = this.keySender('input.keyPress', 'ml');
  public pt_PT = this.keySender('input.keyPress', 'pt-PT');
  public tr = this.keySender('input.keyPress', 'tr');
  public fi = this.keySender('input.keyPress', 'fi');
  public en_US = this.keySender('input.keyPress', 'en-US');
  public el = this.keySender('input.keyPress', 'el');
  public cs = this.keySender('input.keyPress', 'cs');
  public sv = this.keySender('input.keyPress', 'sv');
  public nl = this.keySender('input.keyPress', 'nl');
  public he = this.keySender('input.keyPress', 'he');
  public en = this.keySender('input.keyPress', 'en');
  public es_US = this.keySender('input.keyPress', 'es-US');



  // public type = (text) => {
  //   return this.sendOneWay('input.type', {
  //     text: text
  //   })
  // }
  //for keyboard inputs
  public handleKeyDown(event: KeyboardEvent) {


    this.sendKeyInput('input.type', event);
  }

  public handleKeyUp(event: KeyboardEvent) {
    this.sendKeyInput('input.type', event);
  }

  public sendKeyInput(action: string, event: any) {
    if (typeof event.data === 'string') {
      this.sendOneWay(action, {
        text: event.data
      })
    }
    else {
      let mapped = this.keycodesService[event.data]
      if (mapped) {
        this.sendOneWay(action, {
          text: mapped
        })
      }
    }
    const text = event.key;
  }
  //for backspace old
  // public sendBackspace(action: string, event: any){
  //   this.sendOneWay(action, {
  //     key: "del"
  //   })
  // }
  //for Enter
  public sendEnter(action: string, event: any) {
    this.sendOneWay(action, {
      key: "enter"
    })
  }
  //for backspace
  public sendBackspace(action: string, event: any) {
    this.sendOneWay(action, {
      key: "del"
    })
  }
  //for delete
  public sendDelete(action: string, event: any) {
    this.sendOneWay(action, {
      key: "forward_del"
    })
  }
  //for Arrow keys
  public sendArrowKeys(action: string, event: any) {
    this.sendOneWay(action, event)
  }
  //for keyboard inputs

  public paste = (text) => {
    return this.sendTwoWay('clipboard.paste', {
      text: text
    })
  }

  public copy = () => {
    return this.sendTwoWay('clipboard.copy')
  }


  //@TODO: Refactor this please
  public getClipboardContent = () => {
    this.copy()
      .then((result: any) => {
        if (result.success) {
          if (result.lastData) {
            this.clipboardContent = result.lastData;
          } else {
            this.clipboardContent = 'No clipboard data';
          }
        } else {
          this.clipboardContent = 'Error while getting data';
        }
      });
  }

  public shell = (command) => {
    return this.sendTwoWay('shell.command', {
      command: command
      , timeout: 10000
    })
  }

  public identify = () => {
    return this.sendTwoWay('device.identify')
  }

  public install = (options) => {
    return this.sendTwoWay('device.install', options)
  }

  public uninstall = (pkg) => {
    return this.sendTwoWay('device.uninstall', {
      packageName: pkg
    })
  }

  public reboot = (device) => {
    if (device.ios)
      return this.sendTwoWay('device.rebootIos')
    else
      return this.sendTwoWay('device.reboot')
  }

  public rotate = (rotation: any, lock?: any) => {
    return this.sendOneWay('display.rotate', {
      rotation: rotation,
      lock: lock
    })
  }

  public testForward = (forward) => {
    return this.sendTwoWay('forward.test', {
      targetHost: forward.targetHost
      , targetPort: Number(forward.targetPort)
    })
  }

  public createForward = (forward) => {
    return this.sendTwoWay('forward.create', {
      id: forward.id
      , devicePort: Number(forward.devicePort)
      , targetHost: forward.targetHost
      , targetPort: Number(forward.targetPort)
    })
  }

  public removeForward = (forward) => {
    return this.sendTwoWay('forward.remove', {
      id: forward.id
    })
  }

  public startLogcat = (filters) => {
    return this.sendTwoWayIos('logcat.start', {
      filters: filters
    })
  }

  public stopLogcat = () => {
    return this.sendTwoWayIos('logcat.stop')
  }

  public startRemoteConnect = () => {
    return this.sendTwoWay('connect.start')
  }

  public stopRemoteConnect = () => {
    return this.sendTwoWay('connect.stop')
  }

  public openBrowser = (url, browser) => {
    return this.sendTwoWay('browser.open', {
      url: url
      , browser: browser ? browser.id : null
    })
  }

  public clearBrowser = (browser) => {
    return this.sendTwoWay('browser.clear', {
      browser: browser.id
    })
  }

  public openStore = () => {
    return this.sendTwoWay('store.open')
  }

  public openLanguageSettings = () => {
    return this.sendTwoWay('device.language.open')
  }

  public setLocation = (location: { latitude: number; longitude: number; altitude?: number }) => {
    return this.sendTwoWay('location.set', location);
  }



  public openSetting = () => {
    return this.sendTwoWay('settings.open')
  }

  public screenshot = () => {
    return this.sendTwoWay('screen.capture')
  }

  //ios change
  public screenshotIos = () => {
    return this.sendTwoWay('screen.captureIos')
  }
  //ios change

  public fsretrieve = (file) => {
    return this.sendTwoWay('fs.retrieve', {
      file: file
    })
  }

  public fslist = (dir) => {
    return this.sendTwoWay('fs.list', {
      dir: dir
    })
  }

  public checkAccount = (type, account) => {
    return this.sendTwoWay('account.check', {
      type: type
      , account: account
    })
  }

  public removeAccount = (type, account) => {
    return this.sendTwoWay('account.remove', {
      type: type
      , account: account
    })
  }

  public addAccountMenu = () => {
    return this.sendTwoWay('account.addmenu')
  }

  public addAccount = (user, password) => {
    return this.sendTwoWay('account.add', {
      user: user
      , password: password
    })
  }

  public getAccounts = (type) => {
    return this.sendTwoWay('account.get', {
      type: type
    })
  }

  public getSdStatus = () => {
    return this.sendTwoWay('sd.status')
  }

  public setRingerMode = (mode) => {
    return this.sendTwoWay('ringer.set', {
      mode: mode
    })
  }

  public getRingerMode = () => {
    return this.sendTwoWay('ringer.get')
  }

  public setWifiEnabled = (enabled) => {
    return this.sendTwoWay('wifi.set', {
      enabled: enabled
    })
  }

  public getWifiStatus = () => {
    return this.sendTwoWay('wifi.get')
  }

  public create(target: any, channel: any): ControlService {
    sessionStorage.setItem("device", JSON.stringify(target));
    sessionStorage.setItem("channel", channel);
    this.target = target;
    this.channel = channel;

    return new ControlService(
      this.socketService,
      this.transactionService,
      this.http,
      this.keycodesService
    );
  }

}
